module.exports = __webpack_public_path__ + "img/work-case.c0a41688.svg";